import React from 'react';

import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFemale, faRestroom, faMale } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';

import * as ROUTES from '../../constants/routes';
import data from '../../constants/tournament.json';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';

const TournamentListItem = (props) => {

    const tournament = props.item;
    const { _format, _type } = data;

    const genderIcon = (tournament.gender === "M") ? faMale : (tournament.gender === "F") ? faFemale : faRestroom;

    return (
        <div className="">

            <NavLink className="bg-hover text-decoration-none" to={ROUTES.TOURNAMENT(tournament.uid)}>

                <div className="bg-white border rounded-lg">

                    {tournament.finalized ?
                        <FontAwesomeIcon className="mt-1 mr-2 finalized-icon" color="#f88b97" size="lg" icon={faCalendarCheck} />
                        :
                        <></>
                    }
                    <div className="col p-2 m-0">
                        <div className="border-bottom row align-self-center text-dark small font-weight-bold mr-0 ml-0 pb-1">
                            <FontAwesomeIcon className="mr-2 text-third" size="lg" icon={genderIcon} />
                            <span className="">{tournament.title}</span>
                        </div>

                        <div className="row align-self-center justify-content-start text-dark small mr-0 ml-0 mt-2">
                            <span className="border-right pr-2 mr-2">{_type[tournament.type] || "-"}</span>
                            <span className="">{_format[tournament.format] || "-"}</span>
                        </div>
                    </div>

                </div>
            </NavLink>

        </div>
    )

}

// export default withFirebase(React.memo(TournamentListItem));
export default withFirebase(TournamentListItem);
